// Autonumeric
import AutoNumeric from 'autonumeric';
window.AutoNumeric = AutoNumeric;
